import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { FaBalanceScale, FaFileAlt, FaFileContract } from 'react-icons/fa'

export { FaBalanceScale, FaFileAlt, FaFileContract }

export async function renderIconToPng(IconComponent, color, size = 30) {
  const svgString = renderToStaticMarkup(
    React.createElement(IconComponent, { size, color })
  )

  const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' })
  const url = URL.createObjectURL(blob)

  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = size
      canvas.height = size
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, size, size)
      URL.revokeObjectURL(url)
      canvas.toBlob(pngBlob => {
        if (!pngBlob) { reject(new Error('canvas.toBlob failed')); return }
        pngBlob.arrayBuffer().then(resolve).catch(reject)
      }, 'image/png')
    }
    img.onerror = e => { URL.revokeObjectURL(url); reject(e) }
    img.src = url
  })
}
